import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import toast from "react-hot-toast";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { addNewSert, changeStatus, getSerts, updateSert } from "helpers/fakebackend_helper";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";

const SertList = () => {
  //meta title
  document.title = "SCERT";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [load, setload] = useState(false);
  const [text, setText] = useState("");

  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (contact && contact.name) || "",
      order_by: (contact && contact.order_by) || "",
      tamil_name: (contact && contact.tamil_name) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name"),
      // tamil_name: Yup.string().required("Please Enter Tamil Name"),
      // order_by: Yup.string().required("Please Enter Order by"),
    }),
    onSubmit: values => {
      setload(true)
      if (isEdit) {
        // const updateUser = {
        //   id: contact?.id,
        //   name1: values?.name ?? '',
        //   status: values?.status ?? true
        // };
        const updateClass = {
          scert_master_id: contact?.id,
          eng_name: values["name"],
          tamil_name: text,
          order_by: values['order_by']
        };
        // update user
        // dispatch(onUpdateSert(updateUser));
        updateFun(updateClass);

      } else {
        // const newUser = {
        //   parent_id: null,
        //   name1: values["name"],
        //   name2: '',
        // };
        const newClass = {
          parent_id: null,
          eng_name: values["name"],
          tamil_name: text ?? '',
          order_by: values['order_by']
        };
        addFun(newClass)
      }
    },
  });


  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setLoading] = useState(false)

  

  const [list, setList] = useState([])

  const getList = () => {
    setLoading(true)
    getSerts().then((res) => {
      setList(res)
      setLoading(false)
    }).catch((err) => {
      console.log('err', err)
      setLoading(false)
    })
  }


  useEffect(() => {
    getList()
  }, []);

  const addFun = (payload) => {
    addNewSert(payload).then((res) => {
      setload(false)
      if (res?.success) {
        validation.resetForm()
        getList()
        setModal(false)
        toast.success('Added Success')
      }else {
        toast.error(res?.message ?? 'somthing went wrong!')
      }
    }).catch((err) => {
      console.log('err', err)
      setload(false)
    })
  }

  const updateFun = (payload) => {
    updateSert(payload).then((res) => {
      setIsEdit(false);
      setload(false)
      if (res?.success) {
        validation.resetForm()
        getList()
        setModal(false)
        toast.success('Updated Success')
      }else {
        toast.error(res?.message ?? 'somthing went wrong!')
      }
    }).catch((err) => {
      console.log('err', err)
      setload(false)
    })
  }

  const handleStatus = (status) => {
    changeStatus(status).then(res => {
      if(res?.success){
        getList();
        toast.success(res?.message ?? 'Status Updated')
      }else {
        toast.error(res?.message ?? 'somthing went wrong!')
      }
    }).catch(err => {
      console.log('err', err);
    })
  }



  const toggle = () => {
    setModal(!modal);
  };

  const handleClassClick = arg => {
    const Scert = arg;
    setContact({
      id: Scert.id,
      name: Scert.name1,
      tamil_name : Scert.name2, 
      order_by : Scert.order,
      status: Scert.status
    });
    setText(Scert.name2)
    setIsEdit(true);
    toggle();
  };

  //delete customer
  const handleClassClicks = () => {
    setContact("");
    setIsEdit(false);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell, row) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                {cell.row.index + 1}
              </h5>
            </>
          )
        }
      },
      {
        header: 'English Title',
        accessorKey: 'name1',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                <Link to='#' className='text-dark'>{cell.getValue()}</Link>
              </h5>
            </>
          )
        }
      },
      {
        header: 'Tamil Title',
        accessorKey: 'name2',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Status',
        // accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <div>
              {
                cell.row.original?.status ?
                <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-success">Active</button>
                :
                <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-danger">Deactive</button>
              }
            </div>
          );
        },
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="/subject"
                state={{ id: cellProps.row.original?.id }}
                className="text-primary"
              >
                <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
              </Link>

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const classData = cellProps.row.original;
                  handleClassClick(classData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      {/* <button type="button" className="d-none" id="cloasemodelwhen"   onClick={() =>  toggle()}></button> */}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="" breadcrumbItem="CLASS LIST" />
          <Row>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={list || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search..."
                        isCustomPageSize={true}
                        isAddButton={true}
                        handleUserClick={handleClassClicks}
                        buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                        buttonName="Add Class"
                        tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
            }

            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle} tag="h4">
                {!!isEdit ? "Edit Class" : "Add Class"}
              </ModalHeader>
              <ModalBody>
                <Form
                  onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label className="form-label">English Title<span className="text-danger">*</span></Label>
                        <Input
                          name="name"
                          type="text"
                          placeholder="English Title"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name &&
                              validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name &&
                          validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label className="form-label">Tamil Title<span className="text-danger">*</span></Label>
                        {/* <Input
                          name="tamil_name"
                          type="text"
                          placeholder="தமிழ் எழுதவும்"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.tamil_name || ""}
                          invalid={
                            validation.touched.tamil_name &&
                              validation.errors.tamil_name
                              ? true
                              : false
                          }
                        /> */}
                        <ReactTransliterate
                          value={text}
                          onChangeText={setText}
                          lang="ta" // Tamil Language
                          name="tamil_name"
                          placeholder="Tamil Title"
                          style={{
                            width: "100%",
                            padding: "7px",
                            // fontSize: "16px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                          }}
                        />
                        {validation.touched.tamil_name &&
                          validation.errors.tamil_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.tamil_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label className="form-label">Order By<span className="text-danger">*</span></Label>
                        <Input
                          name="order_by"
                          type="text"
                          placeholder="Order By"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.order_by || ""}
                          invalid={
                            validation.touched.order_by &&
                              validation.errors.order_by
                              ? true
                              : false
                          }
                        />
                        {validation.touched.order_by &&
                          validation.errors.order_by ? (
                          <FormFeedback type="invalid">
                            {validation.errors.order_by}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-end">
                        <button
                          type="submit"
                          disabled={load}
                          className="btn btn-success save-user"
                        >
                          {load ?
                            <>
                              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                              Loading
                            </> :
                            !!isEdit ? "Update" : "Save"}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </ModalBody>
            </Modal>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withRouter(SertList);
